import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'components/Dropdown/Dropdown';
import Datetime from 'react-datetime';
import Moment from 'moment';
import './style.scss';

export class AcceptedDateRange extends Component {
  static propTypes = {
    className: PropTypes.string,
    onSave: PropTypes.func,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    optionType: PropTypes.string
  };

  constructor(props) {
    super(props);

    this.options = [
      { key: 0, value: 'Not accepted' },
      { key: 1, value: 'Accepted' },
      { key: 2, value: 'Accepted with date range' }
    ];

    this.initialValue = null;

    if (props.startDate && props.endDate) {
      this.options[2] = {
        ...this.options[2],
        label: Moment(props.startDate).format('MM/DD/YYYY') + ' - ' + Moment(props.endDate).format('MM/DD/YYYY')
      };

      this.initialValue = this.options[2];
    }
    else if (props.optionType) {
      this.initialValue = this.options.find(x => x.value === props.optionType);
    }

    this.state = {
      value: this.initialValue,
      valueStartDate: null,
      valueEndDate: null,
      fromDate: props.startDate ? Moment(props.startDate) : null,
      toDate: props.endDate ? Moment(props.endDate) : null,
      options: this.options,
      isDisplayPopupCustomValue: false,
      isOpenFromDate: true,
      error: null
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleHideDateRange);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ isKeepShow: false, isDisplayPopupCustomValue: false });

    if (nextProps.startDate !== this.props.startDate || nextProps.endDate !== this.props.endDate) {
      const newOptions = [...this.state.options];
      let newValue = null;

      newOptions[2].label = Moment(nextProps.startDate).format('MM/DD/YYYY') + ' - ' + Moment(nextProps.endDate).format('MM/DD/YYYY');

      if (nextProps.endDate) {
        newValue = nextProps.optionType
          ? newOptions.find(x => x.value === nextProps.optionType)
          : newOptions[2];
      }

      this.setState({
        fromDate: nextProps.startDate ? Moment(nextProps.startDate) : null,
        toDate: nextProps.endDate ? Moment(nextProps.endDate) : null,
        options: nextProps.endDate ? newOptions : this.options,
        value: newValue
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleHideDateRange);
  }

  callbackSelectDate = key => {
    let fromDate = null;
    let toDate = null;
    let keyString = '';

    if (key === 2) {
      fromDate = this.state.fromDate ? this.state.fromDate.format() : null;
      toDate = this.state.toDate ? this.state.toDate.add({day: 1}).format() : null;
      keyString = 'CUSTOM';
    }
    else if (key === 1) {
      keyString = 'ACCEPTED';
    }
    else if (key === 0) {
      keyString = 'NOT_ACCEPTED';
    }

    this.props.onSave(fromDate, toDate, keyString);
  };

  onSelectChange = e => {
    this.setState(
      {
        value: e.value,
        fromDate: null,
        toDate: null,
        error: null
      },
      () => {
        this.callbackSelectDate(e.value ? e.value.key : null);
      }
    );
  };

  onHoverValueCustom = () => {
    const offsetElement = this.customRange.getBoundingClientRect();

    if (
      offsetElement.left + offsetElement.width >
      document.documentElement.clientWidth - 30
    ) {
      let className = this.customRange.getAttribute('class');
      className += ' responsive';
      this.customRange.setAttribute('class', className);
    } else {
      let className = this.customRange.getAttribute('class');
      className.replace('responsive', '');
      this.customRange.setAttribute('class', className);
    }

    this.setState({
      isKeepShow: true,
      isDisplayPopupCustomValue: true
    });
  };

  handleHideDateRange = event => {
    if (!this.state.isDisplayPopupCustomValue ||
      this.customRange.contains(event.target)) { return; }

    if (!this.dd.contains(event.target)) {
      this.setState({
        isKeepShow: false,
        isDisplayPopupCustomValue: false
      });
      if (
        !this.state.value ||
        (this.state.value &&
          this.state.value.key !== 4 &&
          this.state.valueStartDate &&
          this.state.valueEndDate)
      ) {
        this.setState({
          fromDate: null,
          toDate: null
        });
      }
    }
    else {
      this.setState({
        isDisplayPopupCustomValue: false
      });
    }
  };

  onSetValue = () => {
    const stateFromDate = this.state.fromDate;
    const stateToDate = this.state.toDate;

    this.setState({ error: null, isKeepShow: false });

    const startDate = stateFromDate ? Moment(stateFromDate).format('MM/DD/YYYY') : null;
    const endDate = stateToDate ? Moment(stateToDate).format('MM/DD/YYYY') : null;
    let label = '';

    if (startDate) {
      if (endDate) {
        label = startDate + ' - ' + endDate;
      }
      else {
        label = '>= ' + startDate;
      }
    }
    else {
      label = '<= ' + endDate;
    }

    const customCoeOptions = [...this.state.options];
    customCoeOptions[2].label = label;

    this.setState(
      {
        options: customCoeOptions,
        value: this.state.options[2],
        isDisplayPopupCustomValue: false,
        isKeepShow: false,
        valueStartDate: startDate,
        valueEndDate: endDate
      },
      () => {
        this.callbackSelectDate(2);
      }
    );
  };

  onReset = () => {
    this.setState(
      {
        value: null
      },
      () => {
        this.callbackSelectDate(null);
      }
    );
  };

  customRenderDate = item => {
    console.log("customRenderDate", item)
    if (item.key === 2) {
      return item.label;
    } else {
      return item.value;
    }
  };

  checkDate = () => {
    let stateFromDate = this.state.fromDate;
    let stateToDate = this.state.toDate;

    if (stateFromDate && !Moment(stateFromDate).isValid()) {
      this.setState({ error: 'Invalid "From" date'});
    }
    else if (stateToDate && !Moment(stateToDate).isValid()) {
      this.setState({ error: 'Invalid "To" date'});
    }
    else if (stateFromDate && stateToDate && (Moment(stateToDate).diff(Moment(stateFromDate), 'days') < 0)) {
      this.setState({ error: '"To" must be greater than "From".' });
    }
    else {
      this.setState({ error: null });
    }
  }

  customRenderItem = item => {
    console.log("item---", this.state.fromDate)
    if (item.key !== 2) {
      return item.value;
    }

    return (
      <div className='custom-item' ref={ref => { this.customItem = ref; }}>
        {item.value}
        <i className='pe-7s-angle-right' style={{ fontSize: 35, position: 'absolute', right: 0, top: '-45%' }} />

        <div className='custom-range-date box-form-siteone' ref={ref => { this.customRange = ref; }}
          style={ this.state.isDisplayPopupCustomValue ? null : { visibility: 'hidden' } }>
          <div className='col-sm-6 no-padding' style={{ marginTop: 20 }}>
            <div className='custom-group form-group col-sm-12 no-padding' style={{ marginBottom: 10 }}>
              <label className='col-sm-3 no-padding'>From</label>
              <Datetime
                key={'fromDate' + this.state.fromDate}
                className='col-sm-9 custom-input'
                ref={ref => { this.fromDate = ref; }}
                inputProps={{ placeholder: 'mm/dd/yyyy', autoFocus: true }}
                value={this.state.fromDate}
                open={this.state.isDisplayPopupCustomValue}
                timeFormat={false}
                onChange={fromDate => { this.setState({ fromDate: fromDate }, () => { this.checkDate(); }); }}
                closeOnSelect={true}/>
            </div>
            <div className='custom-group form-group col-sm-12 no-padding' style={{ marginBottom: 10 }}>
              <label className='col-sm-3 no-padding'>To</label>
              <Datetime
                key={'toDate' + this.state.toDate}
                className='col-sm-9 custom-input custom-input-to'
                ref={ref => { this.toDate = ref; }}
                inputProps={{ placeholder: 'mm/dd/yyyy' }}
                value={this.state.toDate}
                timeFormat={false}
                onChange={toDate => { this.setState({ toDate: toDate }, () => { this.checkDate(); }); }} 
                closeOnSelect={true}/>
            </div>
            {
              this.state.error && (
                <div className='custom-group form-group col-sm-12 no-padding'>
                  <span className='col-sm-12 no-padding text-danger' style={{ wordBreak: 'break-all' }}>
                    {this.state.error}
                  </span>
                </div>
              )
            }
            <div className='custom-group col-sm-12 no-padding' style={{ marginTop: 10 }}>
            <button
                  className='btn btn-primary btn-siteone'
                  disabled={!this.state.fromDate || !this.state.toDate}
                  onClick={this.onSetValue}
                >
                  Apply
                </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className='custom-date-range'>
        <div className={this.props.className} style={{ padding: 0 }} ref={(ref) => { this.dd = ref; } }>
          <Dropdown
            onChange={this.onSelectChange}
            className='filestring-dropdown filter-dropdown'
            options={this.state.options}
            optionLabel='value'
            value={this.state.value}
            onHoverValue={2}
            onHoverLabel='key'
            onHoverItem={this.onHoverValueCustom}
            showClear={true}
            isKeepShow={this.state.isKeepShow}
            labelTemplate={this.customRenderDate}
            itemTemplate={this.customRenderItem}
            placeholder='Any time'
            style={{ width: '100%' }}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/accepted-date-range/index.js